// extracted by mini-css-extract-plugin
export default {"NumericRangeFeature":"vw_a bhc_b bhc_ux"};